import { COLOR_INFO_60, Conditional, IconMoney, IconPlane, Text } from '@consumidor-positivo/aurora';

import { formatNumber } from '@libs/utils/helpers/formatNumber';
import { formatCurrency } from '@libs/utils/helpers/formatCurrency';

import { MMRewardHighlights } from '../../../../types';

type BenefitTagProps = {
  benefit?: MMRewardHighlights;
};
export const BenefitTag = ({ benefit }: BenefitTagProps) => {
  if (!benefit) return null;

  const benefitType = benefit?.cashback ? 'cashback' : 'miles';
  const benefitValue = benefit?.[benefitType] || 0;
  if (!benefitType || !benefitValue) return null;

  return (
    <div className="mm-tag mm-tag--info">
      <Text as="p" variant="body-small" weight="semibold" className="mm-tag__text">
        <Conditional
          condition={benefitType === 'cashback'}
          renderIf={
            <>
              <IconMoney color="info" size="small" rawColor={COLOR_INFO_60} />
              <div>
                <strong>{formatCurrency(benefitValue)} de cashback</strong> por ano
              </div>
            </>
          }
          renderElse={
            <>
              <IconPlane color="info" size="small" rawColor={COLOR_INFO_60} />
              <div>
                <strong>{formatNumber(benefitValue)} pontos</strong> por ano
              </div>
            </>
          }
        />
      </Text>
    </div>
  );
};
